import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import isEqual from 'lodash/isEqual'
import { CrbMonitorListPayload } from '~bank-crb-monitor/types'

import { CrbMonitorListSchema } from './CrbMonitorListSchema'

export const CRB_LIST = 'crb-list'

export const templatesListQueryOptions = (deps: Partial<Omit<CrbMonitorListPayload, 'id'>>) =>
  queryOptions({
    queryKey: [CRB_LIST, deps],
    queryFn: () => Request.post(Request.urls.bank.crbMonitorList, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })

export const crbMonitorListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    component: lazyRouteComponent(() => import('./CrbMonitorList')),
    validateSearch: (search) => CrbMonitorListSchema.parse(search),
    loaderDeps: ({ search }) => ({
      search: { ...search },
      isChanged: !isEqual(CrbMonitorListSchema.parse({}), search)
    }),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return context.queryClient.getQueryData([CRB_LIST, deps.search]) ?? null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(templatesListQueryOptions(deps.search))
    }
  })
